import { createUniqueId } from 'solid-js'

export function AdFreeIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `ad-free-icon-${id}-paint0`
  const paint1 = `ad-free-icon-${id}-paint1`
  const clip0 = `ad-free-icon-${id}-clip0`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <path
          d="M32.07 7H14.18C10.2146 7 7.00003 10.2146 7.00003 14.18V32.07C7.00003 36.0354 10.2146 39.25 14.18 39.25H32.07C36.0354 39.25 39.25 36.0354 39.25 32.07V14.18C39.25 10.2146 36.0354 7 32.07 7Z"
          fill={`url(#${paint0})`}
        />
        <path
          d="M31.24 11.6799H15.01C13.1709 11.6799 11.68 13.1708 11.68 15.0099V31.2399C11.68 33.079 13.1709 34.5699 15.01 34.5699H31.24C33.0791 34.5699 34.57 33.079 34.57 31.2399V15.0099C34.57 13.1708 33.0791 11.6799 31.24 11.6799Z"
          fill={`url(#${paint1})`}
        />
        <path
          d="M15.45 26.2401C15.45 26.0201 15.51 25.7501 15.68 25.2501L17.19 20.7101C17.58 19.5301 18.13 19.0701 19.18 19.0701C20.23 19.0701 20.76 19.5301 21.15 20.7101L22.65 25.2501C22.78 25.6601 22.84 25.9401 22.84 26.1801C22.84 26.7901 22.4 27.1801 21.74 27.1801C21.13 27.1801 20.77 26.8401 20.55 26.0501L20.39 25.5201H17.83L17.67 26.0501C17.44 26.8601 17.11 27.1801 16.5 27.1801C15.89 27.1801 15.44 26.7901 15.44 26.2401H15.45ZM19.95 23.8901L19.18 21.0801H19.06L18.27 23.8901H19.95Z"
          fill="#68E700"
        />
        <path
          d="M23.7801 20.3399C23.7801 19.5799 24.2301 19.1299 24.9801 19.1299H27.1501C29.5201 19.1299 30.8101 20.5299 30.8101 23.1299C30.8101 25.7299 29.5201 27.1299 27.1501 27.1299H24.9801C24.2201 27.1299 23.7801 26.6799 23.7801 25.9199V20.3399ZM26.7401 25.3299C27.9301 25.3299 28.4401 24.6699 28.4401 23.1299C28.4401 21.5899 27.9301 20.9299 26.7401 20.9299H26.0801V25.3399H26.7401V25.3299Z"
          fill="#68E700"
        />
        <path
          d="M41.255 32.66L41.975 31.94C43.795 30.12 43.795 27.17 41.975 25.36C41.095 24.48 39.925 24 38.685 24C37.445 24 36.275 24.48 35.395 25.36L34.675 26.08L33.955 25.36C33.075 24.48 31.905 24 30.665 24C29.425 24 28.245 24.47 27.365 25.35C25.555 27.17 25.555 30.12 27.365 31.94L28.085 32.66L27.365 33.38C25.545 35.2 25.545 38.15 27.365 39.96C28.245 40.84 29.415 41.32 30.655 41.32C31.895 41.32 33.065 40.84 33.945 39.96L34.665 39.24L35.385 39.96C36.265 40.84 37.435 41.32 38.675 41.32C39.915 41.32 41.085 40.84 41.965 39.96C43.785 38.14 43.785 35.19 41.965 33.38L41.245 32.66H41.255Z"
          fill="white"
        />
        <path
          d="M37.665 32.6601L40.185 30.1401C41.015 29.3101 41.015 27.9701 40.185 27.1501C39.355 26.3301 38.015 26.3201 37.195 27.1501L34.675 29.6701L32.155 27.1501C31.325 26.3201 29.985 26.3201 29.165 27.1501C28.345 27.9801 28.335 29.3201 29.165 30.1401L31.685 32.6601L29.165 35.1801C28.335 36.0101 28.335 37.3501 29.165 38.1701C29.575 38.5801 30.115 38.7901 30.665 38.7901C31.215 38.7901 31.745 38.5801 32.165 38.1701L34.685 35.6501L37.205 38.1701C37.615 38.5801 38.155 38.7901 38.705 38.7901C39.255 38.7901 39.785 38.5801 40.205 38.1701C41.035 37.3401 41.035 36.0001 40.205 35.1801L37.685 32.6601H37.665Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="14.94"
          y1="40.17"
          x2="30.81"
          y2="7.14"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FF00" />
          <stop offset="0.52" stop-color="#00FF00" stop-opacity="0.89" />
          <stop offset="1" stop-color="#99FF00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="23"
          y1="9.5"
          x2="23"
          y2="30.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#01C801" />
          <stop offset="1" stop-color="#007400" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
